import { FUNCTIONS_BASE_URL } from './functionsBase'

export interface DeletionSummary {
  sessionsDeleted: number
  artifactsDeleted: number
  messagesDeleted: number
  organizationsAffected: number
  paymentsAnonymized: number
  note: string
}

/** Permanently delete the signed-in user's data. Irreversible. */
export async function deleteMyData(idToken: string): Promise<DeletionSummary> {
  const response = await fetch(`${FUNCTIONS_BASE_URL}/deleteMyData`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Failed to delete account data')
  }

  return response.json()
}
